import Page from "webPage/Page";
import { pluralise_word } from "base/functions";

Page.register('page-template-search', () => {
    const $wrap = $(".js-search-page");

    if ($wrap.length === 0) {
        return;
    }

    const $input = $wrap.find(".js-search-page-input");

    $wrap.on("click", ".js-clear-search", () => {
        $input.val("").focus();
        return false;
    });

    $input.on("input", () => {
        const value = $input.val();

        $wrap.find(".js-clear-search").toggle(value.length > 0);
    });

    const query = Page.get_query();

    if (query.search) {
        $input.val(query.search);
        $(".js-search-header").text("Results for: " + query.search);

        updateSearchResults(query);
    }
});

async function updateSearchResults(query) {
    const $results = $(".js-search-results");

    try {
        const data = await getSearchResults(query);

        if (!data.results) {
            $results.html(
                eotwJSXFactory('div', {className: "message message--notice"}, [
                    eotwJSXFactory('p', null, ["Sorry, there were no results for your search"])
                ]),
            );
            return;
        }

        $(".js-search-header").text(pluralise_word(data.results.length, " result") + " for: " + query.search);

        $results.html(
            eotwJSXFactory('ul', {className: "search-results"}, [
                data.results.map((result) => {
                    let $reason = null;

                    if (result.type === "department") {
                        if (result.reason === "treatment") {
                            $reason = ["Provides ", eotwJSXFactory('u', null, [result.context])];
                        } else if (result.reason === "condition") {
                            $reason = ["Specialises in ", eotwJSXFactory('u', null, [result.context])];
                        } else if (result.reason === "scan") {
                            $reason = ["Performs ", eotwJSXFactory('u', null, [result.context])];
                        } else if (result.reason === 'keywords') {
                            $reason = ["Matches ", eotwJSXFactory('u', null, [result.context])];
                        }
                    } else if (result.reason === 'keywords') {
                        $reason = ["Matches ", eotwJSXFactory('u', null, [result.context])];
                    }

                    return (
                        eotwJSXFactory('li', {className: `search-results__result search-results__result--${result.type}`}, [
                            eotwJSXFactory('a', {href: result.url}, [
                                eotwJSXFactory('p', {className: "text-bold"}, [
                                    result.type
                                ]),
                                eotwJSXFactory('h3', {className: "heading heading--5"}, [result.name]),
                                $reason
                            ])
                        ])
                    );
                })
            ]),
        );
    } catch (e) {
        console.warn(e);
        $results.html(
            eotwJSXFactory('div', {className: "message message--error"}, [
                eotwJSXFactory('p', null, ["Sorry, there was a problem getting your search results. Please try again later"])
            ]),
        );
    }
}

async function getSearchResults(query) {
    return Ajax.get(null, atob(window.CONFIG.restApiLocation).replace(/wp-json\/$/, '') + 'perform-search', query);
}

export { getSearchResults };
